// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2lEtf","title":"Info_title__3q4oR","links":"Info_links__3YlA-","link":"Info_link__3giVV","logo":"Info_logo__3OMCx"};